import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Update active section
    setActiveSection(sectionId);
    setIsMenuOpen(false);
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  // Update active section based on scroll position
  useEffect(() => {
    if (location.pathname === '/') {
      const handleScroll = () => {
        const sections = ['services', 'benefits', 'why-us', 'contact'];
        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            // If the section is in view (with some buffer for better UX)
            if (rect.top <= 150 && rect.bottom >= 150) {
              setActiveSection(section);
              break;
            }
          }
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [location.pathname]);
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="flex justify-between items-center py-4 md:justify-start md:space-x-10" data-id="element-183">
          <div className="flex justify-start lg:w-0 lg:flex-1" data-id="element-184">
            <Link to="/" className="flex items-center" data-id="element-185">
              <span className="text-2xl font-bold text-navy-800" data-id="element-186">
                Upscend Media
              </span>
            </Link>
          </div>
          <div className="-mr-2 -my-2 md:hidden" data-id="element-187">
            <button type="button" className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-800 hover:text-gray-900 focus:outline-none transition-all duration-300 hover:scale-110" onClick={() => setIsMenuOpen(true)} data-id="element-188">
              <span className="sr-only" data-id="element-189">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-190" />
            </button>
          </div>
          <nav className="hidden md:flex space-x-10" data-id="element-191">
            {location.pathname === '/' ? <>
                <a href="#services" className={`text-base font-medium relative py-2 transition-all duration-300 ease-in-out ${activeSection === 'services' ? 'text-navy-800 scale-105' : 'text-gray-600 hover:text-navy-600 hover:scale-105'}`} onClick={e => {
              e.preventDefault();
              handleNavClick('services');
            }} data-id="element-192">
                  Services
                  <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-navy-600 transform transition-transform duration-300 ease-out ${activeSection === 'services' ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-193"></span>
                </a>
                <a href="#why-us" className={`text-base font-medium relative py-2 transition-all duration-300 ease-in-out ${activeSection === 'why-us' ? 'text-navy-800 scale-105' : 'text-gray-600 hover:text-navy-600 hover:scale-105'}`} onClick={e => {
              e.preventDefault();
              handleNavClick('why-us');
            }} data-id="element-194">
                  Why Us
                  <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-navy-600 transform transition-transform duration-300 ease-out ${activeSection === 'why-us' ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-195"></span>
                </a>
                <a href="#benefits" className={`text-base font-medium relative py-2 transition-all duration-300 ease-in-out ${activeSection === 'benefits' ? 'text-navy-800 scale-105' : 'text-gray-600 hover:text-navy-600 hover:scale-105'}`} onClick={e => {
              e.preventDefault();
              handleNavClick('benefits');
            }} data-id="element-196">
                  Results
                  <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-navy-600 transform transition-transform duration-300 ease-out ${activeSection === 'benefits' ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-197"></span>
                </a>
              </> : null}
            <Link to="/faq" className={`text-base font-medium relative py-2 transition-all duration-300 ease-in-out ${location.pathname === '/faq' ? 'text-navy-800 scale-105' : 'text-gray-600 hover:text-navy-600 hover:scale-105'}`} onClick={() => window.scrollTo(0, 0)} data-id="element-198">
              FAQ
              <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-navy-600 transform transition-transform duration-300 ease-out ${location.pathname === '/faq' ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-199"></span>
            </Link>
          </nav>
          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0" data-id="element-200">
            {location.pathname === '/' ? <a href="#contact" className={`ml-8 whitespace-nowrap inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium transition-all duration-300 ease-in-out hover:scale-105 ${activeSection === 'contact' ? 'text-white bg-navy-700 scale-105' : 'text-white bg-navy-800 hover:bg-navy-700'}`} onClick={e => {
            e.preventDefault();
            handleNavClick('contact');
          }} data-id="element-201">
                Book a Strategy Call
              </a> : <Link to="/#contact" className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-navy-800 hover:bg-navy-700 transition-all duration-300 ease-in-out hover:scale-105" data-id="element-202">
                Book a Strategy Call
              </Link>}
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50" data-id="element-203">
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" data-id="element-204">
            <div className="pt-5 pb-6 px-5" data-id="element-205">
              <div className="flex items-center justify-between" data-id="element-206">
                <div className="flex items-center" data-id="element-207">
                  <span className="text-xl font-bold text-navy-800" data-id="element-208">
                    Upscend Media
                  </span>
                </div>
                <div className="-mr-2" data-id="element-209">
                  <button type="button" className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-800 hover:text-gray-900 focus:outline-none transition-all duration-300 hover:scale-110" onClick={() => setIsMenuOpen(false)} data-id="element-210">
                    <span className="sr-only" data-id="element-211">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-212" />
                  </button>
                </div>
              </div>
              <div className="mt-6" data-id="element-213">
                <nav className="grid gap-y-8" data-id="element-214">
                  {location.pathname === '/' ? <>
                      <a href="#services" className={`-m-3 p-3 flex items-center rounded-md transition-all duration-300 hover:scale-105 ${activeSection === 'services' ? 'bg-navy-50 text-navy-800 scale-105' : 'hover:bg-gray-50 text-gray-800'}`} onClick={e => {
                  e.preventDefault();
                  handleNavClick('services');
                }} data-id="element-215">
                        <span className={`ml-3 text-base font-medium ${activeSection === 'services' ? 'transform translate-x-2 transition-transform duration-300' : ''}`} data-id="element-216">
                          Services
                        </span>
                      </a>
                      <a href="#why-us" className={`-m-3 p-3 flex items-center rounded-md transition-all duration-300 hover:scale-105 ${activeSection === 'why-us' ? 'bg-navy-50 text-navy-800 scale-105' : 'hover:bg-gray-50 text-gray-800'}`} onClick={e => {
                  e.preventDefault();
                  handleNavClick('why-us');
                }} data-id="element-217">
                        <span className={`ml-3 text-base font-medium ${activeSection === 'why-us' ? 'transform translate-x-2 transition-transform duration-300' : ''}`} data-id="element-218">
                          Why Us
                        </span>
                      </a>
                      <a href="#benefits" className={`-m-3 p-3 flex items-center rounded-md transition-all duration-300 hover:scale-105 ${activeSection === 'benefits' ? 'bg-navy-50 text-navy-800 scale-105' : 'hover:bg-gray-50 text-gray-800'}`} onClick={e => {
                  e.preventDefault();
                  handleNavClick('benefits');
                }} data-id="element-219">
                        <span className={`ml-3 text-base font-medium ${activeSection === 'benefits' ? 'transform translate-x-2 transition-transform duration-300' : ''}`} data-id="element-220">
                          Results
                        </span>
                      </a>
                      <a href="#contact" className={`-m-3 p-3 flex items-center rounded-md transition-all duration-300 hover:scale-105 ${activeSection === 'contact' ? 'bg-navy-50 text-navy-800 scale-105' : 'hover:bg-gray-50 text-gray-800'}`} onClick={e => {
                  e.preventDefault();
                  handleNavClick('contact');
                }} data-id="element-221">
                        <span className={`ml-3 text-base font-medium ${activeSection === 'contact' ? 'transform translate-x-2 transition-transform duration-300' : ''}`} data-id="element-222">
                          Contact
                        </span>
                      </a>
                    </> : null}
                  <Link to="/faq" className={`-m-3 p-3 flex items-center rounded-md transition-all duration-300 hover:scale-105 ${location.pathname === '/faq' ? 'bg-navy-50 text-navy-800 scale-105' : 'hover:bg-gray-50 text-gray-800'}`} onClick={() => {
                setIsMenuOpen(false);
                window.scrollTo(0, 0);
              }} data-id="element-223">
                    <span className={`ml-3 text-base font-medium ${location.pathname === '/faq' ? 'transform translate-x-2 transition-transform duration-300' : ''}`} data-id="element-224">
                      FAQ
                    </span>
                  </Link>
                </nav>
              </div>
            </div>
            <div className="py-6 px-5 space-y-6" data-id="element-225">
              {location.pathname === '/' ? <a href="#contact" className={`w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium transition-all duration-300 hover:scale-105 ${activeSection === 'contact' ? 'text-white bg-navy-700 scale-105' : 'text-white bg-navy-800 hover:bg-navy-700'}`} onClick={e => {
            e.preventDefault();
            handleNavClick('contact');
          }} data-id="element-226">
                  Book a Strategy Call
                </a> : <Link to="/#contact" className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-navy-800 hover:bg-navy-700 transition-all duration-300 hover:scale-105" onClick={() => setIsMenuOpen(false)} data-id="element-227">
                  Book a Strategy Call
                </Link>}
            </div>
          </div>
        </div>}
    </header>;
}